import React from 'react'
import PropTypes from "prop-types"
import Star from './icons/Star'
import StarSm from './icons/StarSm'

const Rating = ({ count, small }) => {
  const stars = [...Array(count)].map((_, i) => (
    <div className="icon star" key={i}>
      {small ? <StarSm /> : <Star />}
    </div>
  ))

  return (
    <div className="rating icons">
      {stars}
    </div>
  )
}

Rating.defaultProps = {
  count: 3,
  small: false
}

Rating.propTypes = {
  count: PropTypes.number,
  small: PropTypes.bool
}

export default Rating
